import { useTranslation } from 'react-i18next';
import { FreelanceOrBusinessOwnershipIncomeVerificationSource } from '../../../api/screening/findOverview';
import ScreeningOverviewStepTable from './ScreeningOverviewStepTable';
import styles from './ScreeningOverviewEmploymentIncomeVerificationSourceStepTable.module.css';
import moment from 'moment/moment';

interface ScreeningOverviewFreelanceOrBusinessOwnershipIncomeSourcesStepTableProps {
    data: FreelanceOrBusinessOwnershipIncomeVerificationSource;
}

const ScreeningOverviewFreelanceOrBusinessOwnershipIncomeVerificationSourcesStepTable = ({
    data
}: ScreeningOverviewFreelanceOrBusinessOwnershipIncomeSourcesStepTableProps) => {
    const { t } = useTranslation();

    const BusinessOwnershipIncomeVerificationSource = [
        {
            title: (
                <div>
                    <span className={styles.incomeSource}>
                        {t('screening.overview.step.IncomeVerificationSource.incomeSource')}</span>
                    {t(`screening.incomeVerification.incomeSourceTypeContent.type.options.${data.type}`)}
                </div>
            ),
            subSections: [
                {
                    title: t('screening.overview.step.businessOwnershipIncomeVerificationSource.companyName'),
                    value: data.employer,
                },
                {
                    title: t('screening.overview.step.businessOwnershipIncomeVerificationSource.chamberOfCommerceNumber'),
                    value: data.chamberOfCommerceNumber,
                },
                {
                    title: t('screening.overview.step.businessOwnershipIncomeVerificationSource.startDate'),
                    value: moment(data.startDate).format('DD-MM-YYYY'),
                },
                {
                    title: t('screening.overview.step.businessOwnershipIncomeVerificationSource.grossIncome'),
                    value: data.grossIncome ? data.grossIncome.toString() : null,
                },
                {
                    title: t('screening.overview.step.businessOwnershipIncomeVerificationSource.grossIncomeRemark'),
                    value: data.grossIncomeRemark,
                },
                {
                    title: t('screening.overview.step.IncomeVerificationSource.uploadedDocuments'),
                    data: [
                        {
                            title: t('screening.overview.step.businessOwnershipIncomeVerificationSource.certifiedChamberOfCommerceExtract.label'),
                            value: data.certifiedChamberOfCommerceExtract
                        },
                        {
                            title: t('screening.overview.step.businessOwnershipIncomeVerificationSource.annualStatement.label'),
                            value: data.annualStatement
                        },
                        {
                            title: t('screening.overview.step.businessOwnershipIncomeVerificationSource.taxReturn.label'),
                            value: data.taxReturn
                        },
                    ]
                }
            ]
        }
    ];

    return (
        <ScreeningOverviewStepTable
            data={BusinessOwnershipIncomeVerificationSource}
        />
    );
}

export default ScreeningOverviewFreelanceOrBusinessOwnershipIncomeVerificationSourcesStepTable;
